import {Component} from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
})
export class SpinnerComponent {}
